<header class="header header--nobanner flex flexAlign-center">

  <div class="header__main">
    <app-logo></app-logo>
    <app-campaign-switcher class="main-header-switcher"></app-campaign-switcher>
    <div class="header__main--nav">
      <app-user-profile-card></app-user-profile-card>
    </div>
  </div>

</header>
